<template>
  <div class="container">
    <div class="search-detail">
        <div class="search-detail-title">{{SearchDetails.title}}</div>
        <div class="search-detail-content" v-html="SearchDetails.content">{{SearchDetails.content}}</div>
    </div>
  </div>
</template>

<script>
import { SeacrhListDetails } from "@/api/search";
export default {
     data() {
         return {
             SearchDetails:''
         }
     },
     mounted() {
         this.requestSeacrhListDetails()
     },
     methods:{
        //  列表详细内容
         requestSeacrhListDetails() {
             let id = this.$route.query.id
            SeacrhListDetails({id:id}).then(res=>{
                 this.SearchDetails = res.data
            }) 
         }
     }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .search-detail {
      width: 100%;
      background-color: #ffffff;
      text-align: left;
      padding: 18px 12px;
      box-sizing: border-box;
      margin-top: 10px;
      .search-detail-title {
          width: 100%;
          font-size: 14px;
          color: #333333;
      }
      .search-detail-content {
          font-size: 13px;
          color: #999999;
          line-height: 1.5;
          margin-top: 19px;
        
      }
  }
}
</style>
